module.exports = __webpack_public_path__ + "img/shiyonggl.371b1cf3.png";